
export const downloadFile = (fileUrl: string, fileName: string = 'download.pdf') => {
  const anchor = document.createElement("a");
  anchor.href = fileUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}